<template>
  <div id="application-wrapper" :style="customCss" v-if="this.customCss">
    <notifications
      group="notice2"
      position="top left"
      width="100%"
      :ignoreDuplicates=true
      :closeOnClick=false
      class="notification2 position-relative"
      :duration=-1
    />

    <!-- this notification is for success messages that shouldn't persist between pages -->
    <notifications
      group="notice"
      position="top left"
      width="100%"
      :ignoreDuplicates=true
      class="notification success"
      :duration=10000
    >
      <template #body="props">
        <div class="vue-notification" :class="props.item.type">
          <p class="title" v-if="props.item.title">
            {{ props.item.title }}
          </p>
          <div v-safe-html="props.item.text"/>
          <button
            @click="props.close"
            class="notification-close">
            ✕
          </button>
        </div>
      </template>
    </notifications>

    <!-- this notification is for success messages that should persist between pages -->
    <notifications
      group="notice3"
      position="top left"
      width="100%"
      :ignoreDuplicates=true
      class="notification success"
      :duration=10000
    >
      <template #body="props">
        <div class="vue-notification" :class="props.item.type">
          <p class="title" v-if="props.item.title">
            {{ props.item.title }}
          </p>
          <div v-safe-html="props.item.text"/>
          <button
            @click="props.close"
            class="notification-close">
            ✕
          </button>
        </div>
      </template>
    </notifications>

    <notifications
      group="notice-stay"
      position="top left"
      width="100%"
      :ignoreDuplicates=true
      class="notification"
      :max=1
      :duration=-1
    >
      <template #body="props">
        <div class="vue-notification" :class="props.item.type">
          <p class="title" v-if="props.item.title">
            {{ props.item.title }}
          </p>
          <div v-safe-html="props.item.text"/>
          <button
            @click="props.close"
            class="notification-close">
            ✕
          </button>
        </div>
      </template>
    </notifications>

    <component :is="layout" />
  </div>
</template>

<script>

import GoogleTagManager from '@/shared/mixins/googleTagManager';
import Localize from './shared/mixins/localize';
import ApplicationLayout from './layouts/ApplicationLayout.vue';
import ajax from './ajax';

export default {
  name: 'app',

  components: {
    'application-layout': ApplicationLayout,
  },

  // mounted() {
  //   this.createVisit();
  // },

  data() {
    return {};
  },

  computed: {
    layout() {
      return 'application-layout';
    },

    customCss() {
      return this.$store.state.partners.currentPartner.settings.sections.custom_css;
    },

    partner() {
      return this.$store.state.partners.currentPartner;
    },

    user() {
      return this.$store.state.users.currentUser;
    },

    weglotSettings() {
      return this.$store.state.partners.currentPartner.settings.weglot_configuration;
    },
  },

  created() {
    // do this only once
    this.initializeLocalizeTag();
    this.initializeGoogleTagManager();
    this.updateFavicon();
    this.initializeWeglot();

    // Add customCss to body tag when loaded
    if (this.customCss) {
      document.body.style = Object.entries(this.customCss).map(([k, v]) => `${k}:${v}`).join(';');
    }

    const { error } = this.$route.query;
    if (error) {
      this.$notify({
        group: 'notice-stay',
        type: 'error',
        text: error,
      });
    }
  },

  methods: {
    createVisit() {
      return ajax.post('/ahoy/visits', {
        landing_page: window.location.href,
        screen_width: window.screen.width,
        screen_height: window.screen.height,
        referrer: document.referrer || null,
        user_id: this.user.id || null,
      }, {
        headers: { 'Content-type': 'application/json' },
      }).catch((error) => {
        console.log(error);
      });
    },

    updateFavicon() {
      const favicon = document.getElementById('va-favicon');
      if (favicon && this.partner.settings.favicon_url) {
        console.log(this.partner.settings.favicon_url);
        favicon.href = this.partner.settings.favicon_url;
      }
    },

    initializeWeglot() {
      if (!this.weglotSettings.enabled || !this.weglotSettings.api_key) { return; }

      const script = document.createElement('script');
      script.src = 'https://cdn.weglot.com/weglot.min.js';
      script.type = 'text/javascript';
      script.onload = () => {
        const inlineScript = document.createElement('script');
        inlineScript.innerHTML = `
          Weglot.initialize({
            api_key: '${this.weglotSettings.api_key}',
            hide_switcher: ${this.weglotSettings.hide_switcher},
          });
        `
        document.head.appendChild(inlineScript);
      }

      document.head.appendChild(script);
    },
  },
  mixins: [Localize, GoogleTagManager],
};
</script>

<style lang="scss">
@import 'assets/stylesheets/application.scss';
</style>
